module.exports = __webpack_public_path__ + "media/images/pen_darkgray-05de6b10.png";